<div *ngIf="loading" class="spinner-container" [@spinnerFade]>
  <h2 class="loading-title">Loading</h2>
  <img [src]="'gifs/loading-fast.gif' | assetVersion" alt="" />
</div>
<div id="app_container" [ngClass]="{'has-trial-banner': showTrialBanner}">
  <app-main-side-menu *ngIf="showSideMenu"></app-main-side-menu>
  <app-free-trial-banner
    *ngIf="showTrialBanner"
    [daysLeft]="bannerDaysLeft"
    [isExpired]="isExpiredUser">
  </app-free-trial-banner>
  <main class="router-content"
        [class.trial-route]="isPublicRoute"
        *ngIf="shouldListenScroll; else noScroll"
        (scroll)="onScroll($event)">
    <router-outlet></router-outlet>
  </main>
  <ng-template #noScroll>
    <main class="router-content" [class.trial-route]="isPublicRoute">
      <router-outlet></router-outlet>
    </main>
  </ng-template>
  <app-notification *ngIf="(showSmallScreensNotification$ | async) && !isPublicRoute"
    [title]="SMALL_SCREENS_NOTIFICATION.title"
    [description]="SMALL_SCREENS_NOTIFICATION.description"
    [icon]="SMALL_SCREENS_NOTIFICATION.icon">
  </app-notification>
</div>
